import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Select,
  MenuItem,
  Tooltip,
  Skeleton,
  Avatar,
  Stack,
  Paper
} from '@mui/material';
import { useSelector } from 'react-redux';
import CalculateIcon from '@mui/icons-material/Calculate';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import BlockIcon from '@mui/icons-material/Block';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import {
  BuildCircle,
  FireTruckOutlined,
  FormatListNumbered,
  Info,
  Inventory2,
  LocalShippingOutlined,
  Tune,
  WarningAmber
} from '@mui/icons-material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Link } from 'react-router-dom';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  formatDateUTCFormat,
  formatDateUTCRangeFilter
} from '../../apis/Utils';
import DatePicker from 'react-date-picker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  GetAgencyLocations,
  GetBookedShipments,
  GetCarrierProSeriesStatus,
  GetCarriers,
  GetShipments,
  GetUserRoles,
  GetUsers
} from '../../apis/Agency';
import HomeIcon from '@mui/icons-material/Home';
import PinDropIcon from '@mui/icons-material/PinDrop';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LocalShipping } from '@material-ui/icons';
import { base_logo_url } from '../../apis/constants';
const ClarityDashboard = () => {
  const UserLoggedInEmail = useSelector(
    state => state.user.UserDetailsObj?.userInfo
  );
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  console.log(UserLoggedInEmail, 'UserLoggedInEmail');
  const assignedPaths = useSelector(
    state => state.userDetails.assignedRoutesArray
  );
  const shipmentsData = useSelector(
    state => state.getShipments.ShipmentDetails
  );
  const [shipmentsInfo, setShipmentsInfo] = useState(shipmentsData);
  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const [locationsLoader, setLocationsLoader] = useState(true);
  const [carriersData, setCarriersData] = useState({});
  const [carriersDataLoader, setCarriersDataLoader] = useState(true);
  const [proNmbSeriesData, setProNmbSeriesData] = useState(true);
  const [proNmbSeriesDataLoader, setProNmbSeriesDataLoader] = useState(true);
  const [allUsers, setAllUsers] = useState({});
  const [usersLoader, setUsersLoader] = useState(true);
  const [adminRoles, setAdminRoles] = useState([]);

  //   if (loading) return <CircularProgress />;
  //   if (error) return <Alert severity='error'>{error}</Alert>;
  const dateFIlterOptions = [
    'Today',
    'Last 7 Days',
    // 'Next 7 Days',
    'Last 30 Days',
    'This Week',
    'Last Week',
    'This Month',
    'Last Month',
    'This Year',
    'Last Year',
    'Range'
  ];
  const invoiceTstdt = new Date();
  const invoiceToDateRange = new Date();
  invoiceTstdt.setDate(new Date().getDate() - 360);
  invoiceToDateRange.setDate(new Date().getDate() + 360);
  const [invoiceDatesRange, setinvoiceDatesRange] = useState({
    from: formatDateUTCRangeFilter(invoiceTstdt),
    to: formatDateUTCRangeFilter(invoiceToDateRange)
  });

  const tstdt = new Date();
  tstdt.setDate(new Date().getDate() - 30);
  const [datesRange, setDatesRange] = useState({
    from: formatDateUTCRangeFilter(tstdt),
    to: formatDateUTCRangeFilter(new Date())
  });
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [dateFilter, setDateFilter] = useState(dateFIlterOptions[2]);
  const [viewShipmentsData, setViewShipmentsData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 100
  });

  const [savedShipments, setSavedShipments] = useState('');
  const [tenderedShipments, setTenderedShipments] = useState('');
  const [bookedShipments, setBookedShipments] = useState('');
  const [inTransitShipments, setInTransitShipments] = useState('');
  const [deliveredShipments, setDeliveredShipments] = useState('');
  const [cancelledShipments, setCancelledShipments] = useState('');
  const [totalShipmentsCount, setTotalShipmentsCount] = useState('');
  const [agencyLocationsArray, setAgencyLocationsArray] = useState([]);
  const [defaultLocations, setDefaultLocations] = useState([]);
  const [mode, setMode] = useState('LTL');
  const [homeLocations, setHomeLocations] = useState([]);
  const [LTLShipments, setLTLShipments] = useState([]);
  const [TLShipments, setTLShipments] = useState([]);
  const [ParcelShipments, setParcelShipments] = useState([]);
  const [disputedInvoices, setDisputedInvoices] = useState([]);
  const [resolvedInvoices, setResolvedInvoices] = useState([]);
  const [disputedInvoiceLoader, setDisputedInvoiceLoader] = useState(true);
  const [resolvedInvoiceLoader, setResolvedInvoiceLoader] = useState(true);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  const handleDisputeInvoice = () => {
    GetShipments(
      AgencyID,
      UserLoggedInEmail.loginId,
      1,
      100,
      'DISPUTED',
      '',
      invoiceDatesRange
    )
      .then(res => {
        res.status === 200 && setDisputedInvoices(res.data.data);
        setDisputedInvoiceLoader(false);
      })
      .catch(err => {
        console.log(err, 'Get Shipments Err---------->');
        setDisputedInvoiceLoader(false);
        // ErrorToast('Get Shipments Invoices Failed!');
        // setHasMore(false);
      });
  };

  const handleResolvedInvoice = () => {
    GetShipments(
      AgencyID,
      UserLoggedInEmail.loginId,
      1,
      100,
      'RESOLVED',
      '',
      invoiceDatesRange
    )
      .then(res => {
        res.status === 200 && setResolvedInvoices(res.data.data);
        setResolvedInvoiceLoader(false);
      })
      .catch(err => {
        console.log(err, 'Get Shipments Err---------->');
        setResolvedInvoiceLoader(false);
        // ErrorToast('Get Shipments Invoices Failed!');
        // setHasMore(false);
      });
  };

  const handleModeChange = value => {
    // const value = e.target.value;
    setMode(value);
    if (value == 'LTL') {
      const bookedShips = LTLShipments.filter(
        items => items.shipmentStatus === 'Booked'
      );
      const Delivered = LTLShipments.filter(
        items => items.shipmentStatus === 'Delivered'
      );
      const InTransit = LTLShipments.filter(
        items => items.shipmentStatus === 'InTransit'
      );
      const Cancelled = LTLShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Tendered = LTLShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Saved = LTLShipments.filter(
        items => items.shipmentStatus === 'Saved'
      );

      setTenderedShipments(Tendered.length);
      setSavedShipments(Saved.length);
      setBookedShipments(bookedShips.length);
      setInTransitShipments(InTransit.length);
      setDeliveredShipments(Delivered.length);
      setCancelledShipments(Cancelled.length);
    } else if (value == 'TL') {
      const bookedShips = TLShipments.filter(
        items => items.shipmentStatus === 'Booked'
      );
      const Delivered = TLShipments.filter(
        items => items.shipmentStatus === 'Delivered'
      );
      const InTransit = TLShipments.filter(
        items => items.shipmentStatus === 'InTransit'
      );
      const Cancelled = TLShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Tendered = TLShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Saved = TLShipments.filter(
        items => items.shipmentStatus === 'Saved'
      );

      setTenderedShipments(Tendered.length);
      setSavedShipments(Saved.length);
      setBookedShipments(bookedShips.length);
      setInTransitShipments(InTransit.length);
      setDeliveredShipments(Delivered.length);
      setCancelledShipments(Cancelled.length);
    } else {
      const bookedShips = ParcelShipments.filter(
        items => items.shipmentStatus === 'Booked'
      );
      const Delivered = ParcelShipments.filter(
        items => items.shipmentStatus === 'Delivered'
      );
      const InTransit = ParcelShipments.filter(
        items => items.shipmentStatus === 'InTransit'
      );
      const Cancelled = ParcelShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Tendered = ParcelShipments.filter(
        items => items.shipmentStatus === 'Tendered'
      );
      const Saved = ParcelShipments.filter(
        items => items.shipmentStatus === 'Saved'
      );

      setTenderedShipments(Tendered.length);
      setSavedShipments(Saved.length);
      setBookedShipments(bookedShips.length);
      setInTransitShipments(InTransit.length);
      setDeliveredShipments(Delivered.length);
      setCancelledShipments(Cancelled.length);
    }
  };

  useEffect(() => {
    handleModeChange('LTL');
  }, [LTLShipments]);

  const handleSuccessShipDetails = async (res, newValue) => {
    console.log(res.data.data, 'resres');
    const LTLshipments = res.data.data.filter(
      items => items.shipmentType === 'LTL'
    );
    const TLshipments = res.data.data.filter(
      items => items.shipmentType === 'TL'
    );
    const Parcelshipments = res.data.data.filter(
      items => items.shipmentType === 'Parcel'
    );
    setLTLShipments(LTLshipments);
    setTLShipments(TLshipments);
    setParcelShipments(Parcelshipments);
    // setTotalShipmentsCount(res.data.pagingInfo.totalCount);
    // setTenderedShipments(res.data.pagingInfo.totalTendered);
    // setSavedShipments(res.data.pagingInfo.totalSaved);
    // setBookedShipments(res.data.pagingInfo.totalBooked);
    // setInTransitShipments(res.data.pagingInfo.totalInTransit);
    // setDeliveredShipments(res.data.pagingInfo.totalDelivered);
    // setCancelledShipments(res.data.pagingInfo.totalCancelled);
    setShipmentsLoader(false);
  };

  const handleSuccessAgencyLocations = res => {
    setAgencyLocationsArray(res?.data?.data);
    const defaultLoc = res?.data?.data?.filter(items => items.isDefault);
    const homeLoc = res?.data?.data?.filter(items => items.isHome);
    setDefaultLocations(defaultLoc);
    setHomeLocations(homeLoc);
    setLocationsLoader(false);
  };

  const handleErrorAgencyLocations = err => {
    setLocationsLoader(false);
  };
  const fetchLocations = () => {
    GetAgencyLocations(AgencyID, 0)
      .then(res => res.status === 200 && handleSuccessAgencyLocations(res))
      .catch(err => handleErrorAgencyLocations(err));
  };

  const handleCarriersData = () => {
    GetCarriers(AgencyID)
      .then(res => {
        const data = res?.data?.data;
        const LTLCarriers = data.filter(items => items.cType === 'LTL');
        const TLCarriers = data.filter(items => items.cType === 'TL');
        const ParcelCarriers = data.filter(items => items.cType === 'Parcel');
        const LTLConfigeredCarriers = LTLCarriers.filter(
          items => items.isConfigured
        );
        const TLConfigeredCarriers = TLCarriers.filter(
          items => items.isConfigured
        );
        const ParcelConfigeredCarriers = ParcelCarriers.filter(
          items => items.isConfigured
        );

        res.status === 200 &&
          setCarriersData({
            LTLApiRes: LTLCarriers,
            TLApiRes: TLCarriers,
            ParcelApiRes: ParcelCarriers,
            LTLCarriers: LTLCarriers.length,
            TLCarriers: TLCarriers.length,
            ParcelCarriers: ParcelCarriers.length,
            LTLConfigeredCarriers: LTLConfigeredCarriers.length,
            TLConfigeredCarriers: TLConfigeredCarriers.length,
            ParcelConfigeredCarriers: ParcelConfigeredCarriers.length
          });
        setCarriersDataLoader(false);
      })
      .catch(err => {
        setCarriersDataLoader(false);
        console.log(err, 'err');
      });

    GetCarrierProSeriesStatus(AgencyID)
      .then(res => {
        res.status === 200 && setProNmbSeriesData(res?.data?.data);
        setProNmbSeriesDataLoader(false);
      })
      .catch(err => {
        setProNmbSeriesDataLoader(false);
        console.log(err, 'err');
      });
  };

  const fetchUserRoles = () => {
    GetUserRoles(AgencyID)
      .then(response => {
        if (response.status === 200) {
          setAdminRoles(
            response?.data?.data.filter(item => item.roleName !== 'Default')
          );
          // setAdminRoleValue(response?.data?.data[0]);
        }
      })
      .catch(err => console.log('eeeeeeeee', err.message));
  };

  const fetchUsers = () => {
    GetUsers(AgencyID)
      .then(response => {
        if (response.status === 200) {
          setUsersLoader(false);
          const allUsers = response?.data?.data?.filter(
            users => !users.isAdmin
          );
          const activeUsers = allUsers?.filter(users => users.active);
          const inactiveUsers = allUsers?.filter(users => !users.active);
          setAllUsers({
            allUsersApi: allUsers,
            activeUsersApi: activeUsers,
            inactiveUsersApi: inactiveUsers,
            allUsers: allUsers.length,
            activeUsers: activeUsers.length,
            inactiveUsers: inactiveUsers.length
          });
        }
      })
      .catch(err => {
        setUsersLoader(false);
        setAllUsers([]);
        console.log('eeeeeeeee', err.message);
      });
  };

  useEffect(() => {
    fetchUserRoles();
    fetchUsers();
    fetchLocations();
    handleDisputeInvoice();
    handleResolvedInvoice();
    handleCarriersData();
  }, []);

  useEffect(() => {
    GetBookedShipments(AgencyID)
      .then(res => res.status === 200 && handleSuccessShipDetails(res))
      .catch(err => {
        setHasMore(false);
      });
  }, []);

  // Utility to chunk array into rows of max 4
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  function StatCounterLoader({ final = 100, duration = 5000 }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
      const step = 1;
      const speed = duration / final;

      const interval = setInterval(() => {
        setCount(prev => {
          if (prev + step >= final) {
            clearInterval(interval);
            return final;
          }
          return prev + step;
        });
      }, speed);

      return () => clearInterval(interval);
    }, [final, duration]);

    return <Typography variant='h3'>{count}</Typography>;
  }

  const menuItems = [
    {
      path: '/quick-quote',
      url: '/quick-quote',
      icon: <CalculateIcon sx={{ fontSize: 40 }} />,
      label: 'Quick Quote'
    },
    {
      path: '/dashboard',
      url: '/dashboard',
      icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
      label: 'Analytics Dashboard'
    },
    {
      path: '/carriers',
      url: '/carriers',
      icon: <LocalShippingOutlinedIcon sx={{ fontSize: 30 }} />,
      label: 'Carriers'
    },
    {
      path: '/users',
      url: '/users',
      icon: <GroupOutlinedIcon sx={{ fontSize: 30 }} />,
      label: 'Users'
    },
    {
      path: '/manage-shipments',
      url: '/manage-shipments',
      icon: (
        <svg
          width='20'
          height='20'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{ fill: 'currentColor' }}
        >
          <path d='M6.33333 6.0625L8 5.22917L9.66667 6.0625V2.10417H6.33333V6.0625ZM3.83333 12.1042V10.4375H8V12.1042H3.83333ZM2.16667 15.4375C1.70833 15.4375 1.31583 15.2744 0.989167 14.9483C0.663055 14.6217 0.5 14.2292 0.5 13.7708V2.10417C0.5 1.64583 0.663055 1.25333 0.989167 0.926667C1.31583 0.600555 1.70833 0.4375 2.16667 0.4375H13.8333C14.2917 0.4375 14.6842 0.600555 15.0108 0.926667C15.3369 1.25333 15.5 1.64583 15.5 2.10417V13.7708C15.5 14.2292 15.3369 14.6217 15.0108 14.9483C14.6842 15.2744 14.2917 15.4375 13.8333 15.4375H2.16667ZM2.16667 13.7708H13.8333V2.10417H11.3333V8.77083L8 7.10417L4.66667 8.77083V2.10417H2.16667V13.7708Z' />
        </svg>
      ),
      label: 'Shipments'
    },
    {
      path: '/view-locations',
      url: '/view-locations',
      icon: <LocationOnOutlinedIcon sx={{ fontSize: 40 }} />,
      label: 'Locations'
    },
    {
      path: '/app-registration',
      url: '/app-registration',
      icon: <AccountTreeOutlinedIcon sx={{ fontSize: 30 }} />,
      label: 'App-Registeration'
    },
    {
      path: '/track-shipments',
      url: '/track-shipment',
      icon: <TimelineIcon sx={{ fontSize: 40 }} />,
      label: 'Track-Shipment'
    },
    {
      path: '/Logs',
      url: '/Logs',
      icon: <WysiwygIcon sx={{ fontSize: 30 }} />,
      label: 'Logs'
    },
    {
      path: '/settings',
      url: '/settings',
      icon: <SettingsIcon sx={{ fontSize: 40 }} />,
      label: 'Settings'
    },
    {
      path: '/invoice-audit',
      url: '/invoice-audit',
      icon: <DescriptionOutlinedIcon sx={{ fontSize: 40 }} />,
      label: 'Invoice-Audit'
    }
  ];
  const filteredPaths = UserIsAdmin
    ? [
        '/quick-quote',
        '/bookshipment',
        '/dispatchshipmentLTL',
        '/bookshipmentTL',
        '/dispatchshipmentTL',
        '/bookshipmentParcel',
        '/dispatchshipmentParcel',
        '/dashboard',
        '/user-dashboard',
        '/new-dashboard',
        '/carriers',
        '/create-carrier',
        '/users',
        '/manage-shipments',
        '/view-locations',
        '/add-locations',
        '/app-registration',
        '/track-shipments',
        '/Logs',
        '/dispatch',
        '/settings',
        '/user-profile',
        '/not-assigned',
        '/invoice-audit',
        '/notifications',
        '/'
      ]
    : assignedPaths?.length
    ? assignedPaths
    : assignedPaths?.filter(mod =>
        ['/quick-quote', '/settings', '/track-shipments', '/dashboard'].some(
          path => mod.includes(path)
        )
      );
  const DynamicMenuGrid = ({ assignedPaths = [], moduleType }) => {
    // Filter allowed items
    const allowedItems =
      menuItems &&
      menuItems?.filter(item => assignedPaths?.includes(item.path));

    // Break into chunks of 4
    const rows = chunkArray(allowedItems, 4);

    return (
      <>
        {rows.map((row, rowIndex) => (
          <Box
            key={rowIndex}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 4,
              mt: rowIndex === 0 ? 0 : 2,
              flexWrap: 'wrap' // Optional for responsive wrapping
            }}
          >
            {row.map((item, index) => (
              <Box
                key={index}
                component={Link}
                to={item.url}
                sx={
                  moduleType === 'common'
                    ? {
                        ml: 2,
                        width: '10vw',
                        height: '90px',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 2,
                        flexDirection: 'column',
                        border: '1px solid #d0d7de',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                        background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
                        transition: 'all 0.3s ease-in-out',
                        cursor: 'pointer', // 👈 adds hand cursor
                        '&:hover': {
                          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.1)',
                          borderColor: '#1976d2'
                        }
                      }
                    : {
                        // width: '130px',
                        // height:"30px",
                        textAlign: 'center',
                        textDecoration: 'none',
                        color: 'inherit',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transition: 'color 0.3s',
                        '&:hover': {
                          color: '#1976d2',
                          cursor: 'pointer'
                        }
                      }
                }
              >
                {item.icon}
                <Typography
                  variant={moduleType === 'common' ? 'body2' : 'body1'}
                  fontWeight={'bold'}
                  fontSize={moduleType === 'common' ? '14' : '16'}
                  mt={1}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </>
    );
  };
  const getStartOfWeek = date => {
    const day = date.getDay(),
      diff = date.getDate() - day + (day == 0 ? -6 : 0);
    return new Date(date.setDate(diff));
  };
  const handleDateFilterChange = value => {
    setShipmentsLoader(true);
    let fromDate;
    let toDate = new Date();
    // setNoRecordMsg('Loading ...');
    switch (value) {
      case 'Today':
        fromDate = new Date();
        toDate = new Date();
        break;
      case 'This Week':
        fromDate = getStartOfWeek(new Date());
        toDate = new Date();
        break;
      case 'Last Week':
        const lastWeekStart = new Date(toDate);
        lastWeekStart.setDate(toDate.getDate() - toDate.getDay() - 7);
        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
        fromDate = lastWeekStart;
        toDate = lastWeekEnd;
        break;
      case 'This Month':
        fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), 1);
        toDate = new Date();
        break;
      case 'Last Month':
        toDate = new Date(toDate.getFullYear(), toDate.getMonth(), 0);
        fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), 1);
        break;
      case 'This Year':
        fromDate = new Date(toDate.getFullYear(), 0, 1);
        toDate = new Date();
        break;
      case 'Last Year':
        fromDate = new Date(toDate.getFullYear() - 1, 0, 1);
        toDate = new Date(toDate.getFullYear(), 0, 0);
        break;
      case 'Last 7 Days':
        toDate = new Date();
        fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 7);
        break;
      case 'Next 7 Days':
        toDate = new Date();
        fromDate = new Date();
        fromDate.setDate(toDate.getDate() + 1);
        toDate.setDate(toDate.getDate() + 7);
        break;
      case 'Last 30 Days':
        toDate = new Date();
        fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 30);
        break;
      case 'Range':
        fromDate = new Date();
        toDate = new Date();
        break;
      default:
        fromDate = toDate;
        break;
    }

    setDateFilter(value);

    if (value !== 'Range') {
      // handleResetPagination();
      setDatesRange({
        from: formatDateUTCRangeFilter(fromDate),
        to: formatDateUTCRangeFilter(toDate)
      });
    }
  };
  const handleResetPagination = () => {
    setViewShipmentsData([]);
    setHasMore(true);
    setPagination({
      ...pagination,
      pageIndex: 1
    });
  };
  const ShipmentsFilter = () => {
    const DateRangeSelector = ({
      column,
      dateField,
      tableCol = true,
      datesRange,
      setDatesRange,
      setDateFilter,
      handleResetPagination
    }) => {
      const [isDialogOpen, setIsDialogOpen] = useState(false);

      const handleDateChange = update => {
        setDateRange(update || [null, null]);
        if (tableCol) {
          column.setFilterValue(update || [null, null]);
        } else {
          if (update[0] && update[1]) {
            let fdate = update[0];
            let tdate = update[1];
            handleResetPagination();
            setDatesRange({
              from: formatDateUTCRangeFilter(fdate),
              to: formatDateUTCRangeFilter(tdate)
            });
            setDateFilter('Range');
            console.log(update, 'update');
          }
        }
      };
      return (
        <DatePicker
          // className='shipment_table_react-datepicker__input-container'
          isClearable={true}
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateChange}
          // placeholderText={tableCol ? `Select ${dateField} range` : dateField}
          // calendarClassName='custom-calendar'
          dateFormat='MMM d, yyyy' // Ensure the format matches your data
          // style={{ minWidth: '500px', borderRadius: '100px' }}
        />
      );
    };
    return (
      <Box sx={{ display: 'flex', textAlign: 'center' }}>
        <Select
          size='small'
          sx={{
            minWidth: 120,
            maxHeight: 40,
            marginRight: '5px',
            fontSize: 12
          }}
          variant='outlined'
          value={dateFilter}
          onChange={e => {
            handleDateFilterChange(e.target.value);
          }}
          // label='R'
        >
          {dateFIlterOptions.map((dfilt, index) => {
            if (dfilt !== 'Range') {
              return (
                <MenuItem sx={{ fontSize: 12 }} key={index} value={dfilt}>
                  {dfilt}
                </MenuItem>
              );
            }
            {
              /* else {
            return (
              <>
                <MenuItem
                  selected={dateFilter === 'Range'}
                  className='d-flex flex-column align-items-start'
                >
                  <Typography>
                    Range
                    {dateFilter === 'Range' && (
                      <span className='' style={{ fontSize: 12 }}>
                        {' '}
                        ({datesRange.from} to {datesRange.to})
                      </span>
                    )}
                  </Typography>
                  <div
                    style={{}}
                    className='w-100 d-flex justify-content-center'
                  >
                    <DateRangeSelector
                      tableCol={false}
                      datesRange={datesRange}
                      setDatesRange={setDatesRange}
                      setDateFilter={setDateFilter}
                      handleResetPagination={handleResetPagination}
                      dateField='Select Range'
                    />
                  </div>
                </MenuItem>
              </>
            );
          } */
            }
          })}

          <MenuItem
            value={'Range'}
            style={{
              opacity: 0,
              height: 0
            }}
          >
            {dateFilter === 'Range' && (
              <div>
                Range ({formatDateUTCFormat(datesRange.from)} to{' '}
                {formatDateUTCFormat(datesRange.to)})
              </div>
            )}
          </MenuItem>
        </Select>
      </Box>
    );
  };

  function DashboardHeader({ userName = 'IFS Coatings', userImage }) {
    return (
      <Paper
        elevation={2}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          px: 4,
          // py: 3,
          height: 90,
          borderRadius: 3,
          background: 'linear-gradient(135deg, #fdfdfd, #f5f5f5)'
          // mb: 4
        }}
      >
        <Grid container alignItems='center' spacing={2}>
          <Grid item>
            <Avatar
              src={userImage}
              alt={userName}
              sx={{
                width: 64,
                height: 64,
                boxShadow: 3,
                border: '2px solid #1976d2'
              }}
            />
          </Grid>
          <Grid item xs>
            <Stack spacing={0.5}>
              <Typography variant='h5' fontWeight='bold' color='text.primary'>
                Dashboard Overview
              </Typography>
              <Typography variant='body1' color='text.secondary'>
                Welcome back, <strong>{userName}</strong>. Here’s what’s
                happening with your shipments today.
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    );
  }

  const FancyDashboardSection = ({
    sectionType = 'shipments',
    UserIsAdmin,
    assignedPaths,
    mode,
    handleModeChange,
    bookedShipments,
    inTransitShipments,
    deliveredShipments,
    cancelledShipments,
    resolvedInvoices,
    disputedInvoices,
    agencyLocationsArray,
    defaultLocations,
    homeLocations,
    shipmentsLoader,
    disputedInvoiceLoader,
    locationsLoader,
    carriersData,
    usersData,
    usersLoader,
    carriersDataLoader,
    DynamicMenuGrid,
    ShipmentsFilter,
    StatCounterLoader
  }) => {
    const statusStyles = {
      Booked: 'info.main',
      InTransit: 'warning.main',
      Delivered: 'success.main',
      Cancelled: 'error.main',
      Resolved: 'success.main',
      Disputed: 'error.main',
      CreatedLocation: 'info.main',
      DefaultLocation: 'success.main',
      Carrier: 'info.main',
      CarrierConfigured: 'success.main'
    };

    const getSectionStats = () => {
      switch (sectionType) {
        case 'shipments':
          return [
            {
              label: 'Booked',
              value: bookedShipments ?? 0,
              icon: <EventAvailableIcon fontSize='small' />,
              color: statusStyles.Booked
            },
            {
              label: 'InTransit',
              value: inTransitShipments ?? 0,
              icon: <LocalShippingIcon fontSize='small' />,
              color: statusStyles.InTransit
            },
            {
              label: 'Delivered',
              value: deliveredShipments ?? 0,
              icon: <CheckCircleIcon fontSize='small' />,
              color: statusStyles.Delivered
            },
            {
              label: 'Tendered',
              value: cancelledShipments ?? 0,
              icon: <Inventory2OutlinedIcon fontSize='small' />,
              color: statusStyles.Cancelled
            }
          ];
        case 'Invoices and Locations':
          return [
            {
              label: 'Resolved Invoices',
              value: resolvedInvoices?.length ?? 0,
              icon: <VerifiedUserIcon fontSize='small' />,
              color: statusStyles.Resolved
              // tooltip: '+5% from yesterday'
            },
            {
              label: 'Disputed Invoices',
              value: disputedInvoices?.length ?? 0,
              icon: <ReportProblemIcon fontSize='small' />,
              color: statusStyles.Disputed,
              tooltip: 'Requires attention'
            },
            {
              label: 'Created Locations',
              value: agencyLocationsArray?.length ?? 0,
              icon: <AddLocationAltIcon fontSize='small' />,
              color: statusStyles.CreatedLocation,
              tooltip: 'List of all locations created',
              list: agencyLocationsArray
            },
            {
              label: 'Default Locations',
              value: defaultLocations?.length ?? 0,
              icon: <HomeWorkIcon fontSize='small' />,
              color: statusStyles.DefaultLocation,
              tooltip: 'Locations set as default',
              list: defaultLocations
            }
          ];

        case 'carriers':
          return [
            {
              label: 'LTL Carriers',
              value: carriersData?.LTLCarriers ?? 0,
              icon: <LocalShipping fontSize='small' />,
              color: statusStyles.Carrier,
              tooltip: 'List of LTL carriers',
              list: carriersData?.LTLApiRes
            },

            {
              label: 'Parcel Carriers',
              value: carriersData?.ParcelCarriers ?? 0,
              icon: <Inventory2 fontSize='small' />,
              color: statusStyles.Carrier,
              tooltip: 'List of Parcel carriers',
              list: carriersData?.ParcelApiRes
            },

            {
              label: 'TL Carriers',
              value: carriersData?.TLCarriers ?? 0,
              icon: <LocalShippingOutlined fontSize='small' />,
              color: statusStyles.Carrier,
              tooltip: 'List of TL carriers',
              list: carriersData?.TLApiRes
            }
          ];
        case 'Users and Roles':
          return [
            {
              label: 'Total Created Users',
              value: usersData.allUsers ?? 0,
              icon: <PersonAddAltIcon fontSize='small' />,
              color: statusStyles.Carrier,
              tooltip: 'List of All Users',
              list: usersData?.allUsersApi
            },

            {
              label: 'Active Users',
              value: usersData.activeUsers ?? 0,
              icon: <HowToRegIcon fontSize='small' />,
              color: statusStyles.Delivered,
              tooltip: 'List of Active Users',
              list: usersData?.activeUsersApi
            },

            {
              label: 'Inactive Users',
              value: usersData.inactiveUsers ?? 0,
              icon: <BlockIcon fontSize='small' />,
              color: statusStyles.Cancelled,
              tooltip: 'List of Inactive Users',
              list: usersData?.inactiveUsersApi
            },
            {
              label: 'Total Created Roles',
              value: adminRoles.length ?? 0,
              icon: <PersonAddAltIcon fontSize='small' />,
              color: statusStyles.Carrier,
              tooltip: 'List of All Users',
              list: adminRoles
            }
          ];
        default:
          return [];
      }
    };

    const stats = getSectionStats();

    return (
      <Grid item xs={12} sx={{ p: 1 }}>
        <Box sx={{ display: 'flex', mb: 2 }}>
          <Paper
            sx={{
              display: 'flex',
              // justifyContent: 'center',
              alignItems: 'center',
              width: '350px',
              borderRadius: 2,
              p: 1,
              m: 1,
              background: 'linear-gradient(145deg, #ffffff, #f5f5f5)'
            }}
          >
            <Typography variant='h6' sx={{}}>
              📊 {sectionType.charAt(0).toUpperCase() + sectionType.slice(1)}{' '}
              Overview
            </Typography>
          </Paper>
          {sectionType === 'shipments' && (
            <Paper
              sx={{
                display: 'flex',
                // justifyContent: 'center',
                alignItems: 'center',
                width: '230px',
                borderRadius: 2,
                p: 1,
                m: 1,
                background: 'linear-gradient(145deg, #ffffff, #f5f5f5)'
              }}
            >
              <FormControl sx={{ display: 'flex' }} component='fieldset'>
                <RadioGroup
                  row
                  name='shipping-mode'
                  value={mode}
                  onChange={e => handleModeChange(e.target.value)}
                >
                  {['LTL', 'TL', 'Parcel'].map(option => (
                    <FormControlLabel
                      key={option}
                      value={option}
                      control={<Radio size='small' />}
                      label={option}
                      sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Paper>
          )}

          {/* {sectionType === 'shipments' && (
            <>

              <Paper
                sx={{
                  display: 'flex',
                  // justifyContent: 'center',
                  alignItems: 'center',
                  width: '140px',
                  borderRadius: 2,
                  p: 1,
                  m: 1,
                  background: 'linear-gradient(145deg, #ffffff, #f5f5f5)'
                }}
              >
                <ShipmentsFilter />
              </Paper>
            </>
          )} */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'start',
            gap: 3,
            cursor: 'pointer'
          }}
        >
          {stats.map((item, index) => (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#f2f2f2',
                    color: '#1e1e2f',
                    boxShadow: 3,
                    borderRadius: 2,
                    fontSize: 14,
                    maxHeight: 500,
                    minWidth: 400,
                    width: 'auto'
                  }
                },
                arrow: {
                  sx: {
                    '&:before': {
                      backgroundColor: '#f2f2f2'
                    }
                  }
                }
              }}
              key={index}
              title={
                item.list ? (
                  <Box
                    sx={{
                      maxHeight: 500,
                      minWidth: 400,
                      width: 'auto',
                      overflow: 'auto',
                      p: 1
                    }}
                  >
                    <Typography variant='body1' fontWeight='bold'>
                      {item.label} Details
                    </Typography>
                    {item.list.map((entry, i) => {
                      const isLocation = item.label?.includes('Locations');
                      const isCarriers = item.label?.includes('Carriers');
                      const isUser = item.label?.includes('Users');
                      const isRole = item.label?.includes('Roles');

                      const showAvatar = !isLocation && !isRole;

                      const avatarSrc = isUser
                        ? base_logo_url + entry.avatar
                        : base_logo_url + entry.logo;

                      const displayName =
                        isCarriers || isLocation
                          ? entry.name
                          : isRole
                          ? entry.roleName
                          : `${entry.firstName} ${entry.lastName}`;

                      return (
                        <Typography
                          key={i}
                          variant='body2'
                          sx={{
                            p: 1,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <b>{i + 1}:</b>
                          {showAvatar && (
                            <Avatar
                              src={avatarSrc}
                              alt={entry.logo}
                              sx={{
                                width: 44,
                                height: 44,
                                boxShadow: 3,
                                border: '1px solid #1976d2'
                              }}
                            />
                          )}
                          <b>{displayName}</b>
                          {isLocation && entry.streetLines}
                        </Typography>
                      );
                    })}
                  </Box>
                ) : (
                  item.tooltip || ''
                )
              }
              arrow
              placement='top'
            >
              <Paper
                elevation={3}
                sx={{
                  minWidth: 180,
                  flex: 1,
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 4,
                  background: 'linear-gradient(135deg, #fff, #f8f8f8)',
                  transition: 'all 0.3s ease-in-out',
                  borderLeft: `5px solid`,
                  borderColor: item.color,
                  '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
                  }
                }}
              >
                {(!carriersDataLoader || sectionType !== 'carriers') &&
                (!disputedInvoiceLoader || sectionType !== 'invoices') &&
                (!shipmentsLoader || sectionType !== 'shipments') ? (
                  <Typography variant='h4' sx={{ color: item.color }}>
                    {item.value}
                  </Typography>
                ) : (
                  <Skeleton variant='rounded' width={45} height={40} />
                )}

                <Typography
                  variant='body2'
                  fontWeight='bold'
                  sx={{
                    color: item.color,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    mt: 1
                  }}
                >
                  {item.label} {item.icon}
                </Typography>
              </Paper>
            </Tooltip>
          ))}
        </Box>
      </Grid>
    );
  };
  return (
    <Grid
      sx={{
        m: 4,
        mt: 0,
        maxHeight: '93vh',
        overflow: 'auto'
      }}
      // spacing={1}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          p: 2,
          display: 'flex',
          textAlign: 'left'
        }}
      >
        <Grid container gap={1}>
          <Grid item>
            <DashboardHeader
              userName={
                UserLoggedInEmail.firstName + ' ' + UserLoggedInEmail.lastName
              }
              userImage={base_logo_url + UserLoggedInEmail.avatar}
            />
          </Grid>
          <DynamicMenuGrid moduleType='common' assignedPaths={filteredPaths} />
          <Grid item xs={12} sx={{ p: 1 }}>
            <FancyDashboardSection
              sectionType='shipments'
              UserIsAdmin={UserIsAdmin}
              assignedPaths={assignedPaths}
              mode={mode}
              handleModeChange={handleModeChange}
              bookedShipments={bookedShipments}
              inTransitShipments={inTransitShipments}
              deliveredShipments={deliveredShipments}
              cancelledShipments={cancelledShipments}
              shipmentsLoader={shipmentsLoader}
              DynamicMenuGrid={DynamicMenuGrid}
              ShipmentsFilter={ShipmentsFilter}
              StatCounterLoader={StatCounterLoader}
            />
          </Grid>
          <Grid item xs={12} sx={{ p: 1 }}>
            <FancyDashboardSection
              sectionType='Invoices and Locations'
              UserIsAdmin={UserIsAdmin}
              StatCounterLoader={StatCounterLoader}
              resolvedInvoices={resolvedInvoices}
              disputedInvoices={disputedInvoices}
              agencyLocationsArray={agencyLocationsArray}
              defaultLocations={defaultLocations}
              homeLocations={homeLocations}
              disputedInvoiceLoader={disputedInvoiceLoader}
              locationsLoader={locationsLoader}
            />
          </Grid>
          <Grid item xs={12} sx={{ p: 1 }}>
            <FancyDashboardSection
              sectionType='carriers'
              UserIsAdmin={UserIsAdmin}
              carriersData={carriersData}
              carriersDataLoader={carriersDataLoader}
            />
          </Grid>
          <Grid item xs={12} sx={{ p: 1 }}>
            <FancyDashboardSection
              sectionType='Users and Roles'
              UserIsAdmin={UserIsAdmin}
              usersData={allUsers}
              usersLoader={usersLoader}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default ClarityDashboard;
